const headerPopover = '1010';

export default {
  headerPopover,
};
